"use strict";
var settings = require('ofs/settings');


var trackBing16 = function(event, action, label, value) {
  if (settings.tracking.gactive && settings.tracking.bingTracking) {

    var uetqGoal16 = window.uetqGoal16 || [ ];
    uetqGoal16.push({
      'ec': event,
      'ea': action,
      'el': label || '',
      'ev': value || 1
    });

  } else {
    console.log('Bing tracking (goal 16) disabled', event, action, label, value);
  }
};

module.exports = trackBing16;


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/core/utils/tracking/bing16.js
 **/